import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import Immutable from 'immutable';

import { bindAll } from '@bibliocommons/utils-react';

import ClearableTextField from 'app/components/shared/ClearableTextField';

export class WebItemTitleInput extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleChange(value) {
    this.props.handleWebItemPropertyChange(Immutable.Map({ title: value }));
  }

  handleClear() {
    this.props.handleWebItemPropertyChange(Immutable.Map({ title: '' }));
  }

  render() {
    return (
      <div className="cp-web-item-title-input">
        <label htmlFor="web-item-title-input" id="web-item-title-label">
          <FormattedMessage id="user_list_website_title" />
        </label>
        <ClearableTextField
          value={this.props.value}
          id="web-item-title-input"
          labelledById="web-item-title-label"
          maxLength={4000}
          handleChange={this.handleChange}
          handleClear={this.handleClear}
          inputTestId="web-item-title-input"
          hideClearButton={!this.props.value}
          clearButtonSrText={<FormattedMessage id="ada_label_clear_title_text" />}
          characterCountSrOnly
          focus
        />
      </div>
    );
  }
}

WebItemTitleInput.propTypes = {
  value: PropTypes.string,
  handleWebItemPropertyChange: PropTypes.func.isRequired
};

export default injectIntl(WebItemTitleInput);
